module.exports = __webpack_public_path__ + "img/data-availability-005.8f85180f.jpg";